export default "__VITE_ASSET__BaitC2jD__"